import { DAYS, DEFAULT_LANGUAGE, MONTHS } from './constants.js';

export const padWithZero = (val) => val.toString().padStart(2, '0');

export const formatHms = (hours, minutes, seconds) =>
    `${padWithZero(hours)}:${padWithZero(minutes)}:${padWithZero(seconds)}`;

export const extractDateAndTimeFromTimestamp = (timestamp, language = DEFAULT_LANGUAGE) => {
    const d = new Date(timestamp);
    let date, time;
    if (language === 'he-IL') {
        date = `${DAYS[language][d.getDay()]} ${padWithZero(d.getDate())} ${MONTHS[language][d.getMonth()]}`;
        time = padWithZero(d.getHours()) + ':' + padWithZero(d.getMinutes());
    } else {
        date = (
            DAYS[language][d.getDay()] + " "
            + padWithZero(d.getDate()) + " "
            + MONTHS[language][d.getMonth()]
        );
        time = padWithZero(d.getHours()) + ':' + padWithZero(d.getMinutes());
    }
    return [date, time]
}

export const timeAgo = (ms) => {
    const timeDiffSec = ms / 1000;
    const hours = Math.floor(timeDiffSec / 3600);
    const minutes = Math.floor((timeDiffSec % 3600) / 60);
    const seconds = Math.round((timeDiffSec % 3600) % 60);
    return [hours, minutes, seconds];
}

export const getSecondsSince = (timestamp) => {
    const timeDiffMs = (new Date()) - (new Date(timestamp));
    return timeDiffMs / 1000;
}

export const hoursMinutesSecondsSince = (timestamp, since) => {
    const from = since ? new Date(since) : new Date();
    const timeDiffMs = (from - (new Date(timestamp)));
    return timeAgo(timeDiffMs);
}

export const lessThanAnHourAgo = (timestamp, since) => {
    const [hours, ,] = hoursMinutesSecondsSince(timestamp, since);
    return hours < 1
}

export const diffMoreThan24Hours = (previous, current) => {
    if (!previous) return false;

    const diffMs = (new Date(current)) - (new Date(previous));
    const [hours, ,] = timeAgo(diffMs);
    return hours >= 24;
}

export const toDatetimeLocalValue = (timestamp) => {
    const d = new Date(timestamp);
    return `${d.getFullYear()}-${padWithZero(d.getMonth() + 1)}-${padWithZero(d.getDate())}`
        + `T${padWithZero(d.getHours())}:${padWithZero(d.getMinutes())}`;
}

export const fromDatetimeLocalValue = (value) => (new Date(value)).toISOString();

export const toTimeLocalValue = (timestamp) => {
    const d = new Date(timestamp);
    return `${padWithZero(d.getHours())}:${padWithZero(d.getMinutes())}`;
}

export const withUpdatedTime = (timestamp, timeValue) => {
    const [hours, minutes] = timeValue.split(':').map(Number);
    const d = new Date(timestamp);
    d.setHours(hours, minutes, 0, 0);
    return d.toISOString();
}

export const isSameDay = (a, b) => {
    const dA = new Date(a);
    const dB = new Date(b);
    return dA.getFullYear() === dB.getFullYear()
        && dA.getMonth() === dB.getMonth()
        && dA.getDate() === dB.getDate();
}

export const doesStartNewDay = (previous, current) => {
    if (!previous || !current) return false;

    const previousDate = new Date(previous);
    const currentDate = new Date(current);

    return previousDate.getDate() !== currentDate.getDate();
}
